import React from 'react'

const Dropdown = () => {
  return (
    <div>
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 5.5L10 0.5H0L5 5.5Z" fill="black"/>
</svg>

    </div>
  )
}

export default Dropdown
